// javascript/controllers/sidebar_controller.js
import { Controller } from "@hotwired/stimulus"
import { enter, leave } from "el-transition"
import { useClickOutside } from 'stimulus-use'

export default class extends Controller {
  static targets = ['container', 'panel', 'closeButton', 'backdrop']

  connect() {
    useClickOutside(this, { element: this.panelTarget })
  }

  clickOutside(event) {
    event.preventDefault()
    this.close()
  }


  open() {
    this.containerTarget.classList.remove("hidden");
    enter(this.backdropTarget);
    enter(this.closeButtonTarget);
    enter(this.panelTarget);
  }

  close() {
    Promise.all([
      leave(this.backdropTarget),
      leave(this.closeButtonTarget),
      leave(this.panelTarget),
    ]).then(() => {
      this.containerTarget.classList.add("hidden");
    });
  }

}
